// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ca63c93a","732":"14611c1f"}[chunkId] + ".chunk.js";
};